<div class="card dashed bg-transparent">
  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>
